import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../customerspages.service';
import { SwapPaginationComponent } from 'src/app/custom-component/pagination/pagination.component';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-customers-stories',
  templateUrl: './customers-stories.component.html',
  styleUrls: ['./customers-stories.component.scss'],
  imports: [SwapPaginationComponent, CommonModule, UrlParamsPipe],
})
export class CustomersStoriesComponent implements OnInit, OnDestroy {
  queryParams: any;
  constructor(
    private customersPagesService: CustomerspagesService, 
    private route: ActivatedRoute,
    private posthogService: PosthogService
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  isPagination: boolean = true;
  storiesData = [
    {
      fields: {
        customerStoryHeroPanel: {
          fields: {
            title: '',
            image: [
              {
                fields: {
                  file: {
                    url: '',
                  },
                  title: '',
                },
              },
            ],
          },
        },
        webPageId: '',
      },
    },
  ];
  storiesHeader: string = '';

  page = 1;

  ngOnInit(): void {
    this.customersPagesService.customersData$.subscribe(data => {
      if (data != null) {
        this.storiesData = data?.customerStoriesElements;
        this.storiesHeader = data?.customerStoriesElementsTitle;
      }
    });
  }
  onchangePageSize(pageNumber:any) {
    this.page = pageNumber.page;
  }

  onCaseStudyClick(title: string, companyName: string, url: string): void {
    this.posthogService.captureCaseStudyClick(companyName, {
      contentTitle: title,
      location: 'customer_stories_page',
      destinationUrl: url
    });
  }
}
